import Organization from "./Organization";
import Status from "./Status";
import OrganizationalRole from "./OrganizationRole";
import Group from "./Group";

export default class User {
  public id: string = "";
  public email: string = "";
  public password: string = "";
  public displayName: string = "";
  public firstName: string = "";
  public lastName: string = "";
  public organization!: Organization;
  public status: Status = new Status();
  public description: string = "";
  public lastLoggedInAt: string = "";
  public createdAt: string = "";
  public updatedAt: string = "";
  public roles: Array<OrganizationalRole> = [];
  public groupIds: Array<Group> = [];
  public isLoggedIn: boolean = false;
  public isSSOUser: boolean = false;
  public roleNames: Array<string> = [];

  constructor(
    id: string = "",
    email: string = "",
    displayName: string = "",
    firstName: string = "",
    lastName: string = "",
    orgName: string = "",
    description: string = "",
    lastLoggedInAt: string = "",
    createdAt: string = "",
    updatedAt: string = ""
  ) {
    this.id = id;
    this.email = email;
    this.displayName = displayName;
    this.firstName = firstName;
    this.lastName = lastName;
    this.organization = new Organization(orgName);
    this.description = description;
    this.lastLoggedInAt = lastLoggedInAt;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }
}
